import './style.scss';

import { MediaGroupContext } from 'containers/MediaGroupsContainer/context';
import { LanguageContext } from 'providers/Language';
import { forwardRef, MouseEvent, Ref, useContext } from 'react';

type LinkInternalProps = {
  page: number;
};

const LinkInternal = forwardRef<HTMLButtonElement, LinkInternalProps>(
  ({ page }, ref: Ref<HTMLButtonElement>) => {
    const { onDeepLink } = useContext(MediaGroupContext);
    const { t } = useContext(LanguageContext);

    const handleOnClick = (e: MouseEvent<HTMLButtonElement>) => {
      const { currentTarget } = e;
      currentTarget.blur();
      page && onDeepLink(page);
    };

    return (
      <button
        type="button"
        onClick={handleOnClick}
        className="linkinternal"
        aria-label={`${t('goToPage')} ${page}`}
        ref={ref}
      />
    );
  },
);
export default LinkInternal;
